import { useGlobalData } from "@/app/global_data"
import { SelectorProps, useSelector } from "@/app/providers/selector_provider"
import { Entity } from "@/app/types"
import { ComparisonNew } from "@/app/types/comparison_new"
import { Button } from "@/components/buttons/button"
import { getComparisonSelectorOptions } from "@/utils/comparison_selector_options"
import { ComponentProps, useMemo } from "react"

type GroupCountButtonProps = {
  entity: Entity
  comparison: ComparisonNew
  className?: string
  comparisonGroupFilter?: string[]
} & ComponentProps<"button">

export function ComparisonSelectorButton({
  entity,
  comparison,
  className,
  comparisonGroupFilter,
  ...props
}: GroupCountButtonProps) {
  const globalData = useGlobalData()
  const { showSelector, isSelectorShown } = useSelector()

  const { comparisonSelector } = getComparisonSelectorOptions(
    entity,
    comparison,
    (id) => globalData.setGroup(id).notify()
  )

  let filteredComparisonSelector: SelectorProps = comparisonSelector

  // filter options in comparison selector
  if (comparisonGroupFilter) {
    const filteredOptions = comparisonSelector.options[0].items.filter(
      (item) => !comparisonGroupFilter.includes(item.key)
    )

    filteredComparisonSelector = {
      ...comparisonSelector,
      options: [
        {
          ...comparisonSelector.options[0],
          items: filteredOptions,
        },
      ],
    }
  }

  const screenWidth = window.innerWidth
  const isMobileScreen = screenWidth <= 768

  const comparisonGroupText = useMemo(() => {
    const groupName = comparison.getGroupName(entity.isFund())
    const slicedGroupName = isMobileScreen ? groupName.slice(0, 30) : groupName
    return (
      slicedGroupName +
      `${groupName.length > 30 && isMobileScreen ? "..." : ""}`
    )
  }, [entity, comparison])

  return (
    <Button
      {...props}
      color="secondary"
      className={className}
      onClick={() => {
        if (entity && !isSelectorShown)
          showSelector({ ...filteredComparisonSelector })
      }}>
      {comparisonGroupText}
    </Button>
  )
}
